// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"51b85b71","394":"2b73d310","554":"2b73d310","826":"2b73d310"}[chunkId] + ".chunk.css";
};